import React from "react";
import { Card } from "react-bootstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/pro-solid-svg-icons';

const Pill = ({
  active=false,
  label,
  onClick,
  subLabel,
  value,
}) => {
  return (
    <div
      className="d-flex justify-content-between pointer"
      key={value}
      onClick={() => onClick(value)}
      style={{
        border: `1px solid ${active ? "#08173A" : "#DEE2E6"}`,
        borderRadius: "40px",
        padding: "8px 16px",
      }}
    >
      <div className="body-medium-semibold my-auto">
        {label}
      </div>
      <div
        className="body-medium-bold"
        style={{
          backgroundColor: "#E9F1FB",
          borderRadius: "40px",
          color: "#2862FA",
          marginLeft: "10px",
          padding: "2px 8px",
        }}
      >
        {subLabel}
      </div>
    </div>
  );
};

const PillMultiSelect = ({
  display,
  onClose,
  options,
  selected,
  setSelected,
  title,
}) => {
  if (!display) return <span></span>;

  const handleClick = (value) => {
    const newSelected = selected.includes(value)
      ? selected.filter((v) => v !== value)
      : [...selected, value];
    setSelected(newSelected);
  }

  return (
    <Card
      className="my-3 px-3 py-2"
    >
      <div className="d-flex justify-content-between my-2">
        <div className="body-medium-semibold text-muted my-auto">
          {title}
        </div>
        <FontAwesomeIcon
          className="p-2 pointer"
          icon={faXmark}
          onClick={onClose}
          size="lg"
        />
      </div>
      <div
        className="my-1"
        style={{
          display: "flex",
          flexWrap: "wrap",
          gap: "16px",
        }}
      >
        {options.map((option) => (
          <Pill
            key={option.value}
            active={selected.includes(option.value)}
            label={option.label}
            onClick={handleClick}
            subLabel={option.sub_label}
            value={option.value}
          />
        ))}
      </div>
    </Card>
  )
};

export default PillMultiSelect; 